import type { TypeRequestReason } from '../../../request/types';

// ----------------------------------------------------------------------------

// Narrows a reason coming off the request layer down to a known TypeRequestReason.
function mapReason(value: unknown): TypeRequestReason {
    if (value === 'success') {
        return 'success';
    }
    if (value === 'failed') {
        return 'failed';
    }
    if (value === 'error') {
        return 'error';
    }
    if (value === 'abort') {
        return 'abort';
    }
    if (value === 'timeout') {
        return 'timeout';
    }
    return 'error';
}

/*
 * Statuses worth another attempt: 0 is a request that never got a response (dropped
 * connection, CORS), the rest are the transient server-side ones. Every other 4xx is a
 * deterministic rejection that would fail again unchanged.
 */
function isRetryableStatus(status: number | null | undefined): boolean {
    if (status == null) {
        return false;
    }

    if (status === 0 || status === 408 || status === 429) {
        return true;
    }

    /*
     * The whole 5xx range, not just 500-504: a reverse proxy or CDN in front of the server
     * answers 52x when the origin is momentarily unreachable, which is exactly the transient
     * case retries exist for. 501 and 505 are the deterministic exceptions — an unimplemented
     * method or an unsupported HTTP version fails again unchanged.
     */
    return status >= 500 && status <= 599 && status !== 501 && status !== 505;
}

// ----------------------------------------------------------------------------

export { mapReason, isRetryableStatus };
